module.exports = __webpack_public_path__ + "static/img/mobile.6378391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile.png
// module id = V6aI
// module chunks = 0